import React from 'react';

import { useTranslation } from 'providers/GILT.provider';

const TooltipThankYou = () => {
  const { t } = useTranslation();

  return (
    <div className="info-tooltip" data-bem="TooltipThankYou">
      <i>{t('clientConnect.tooltipGuide')}</i>
      <div className="client-info-icon">
        <span className="tooltip">
          <div className="tooltip-centered">{t('clientConnect.thankUTooltipText')}</div>
        </span>
      </div>
    </div>
  );
};

export default TooltipThankYou;
